<template>
  <default>
    <div class="cust-pa-wrap">
      <pa-sale-page channel="customer" />
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import PaSalePage from '@/components/pa/PaSalePage';

export default {
  name: 'CustomerPaSale',
  components: { Default, PaSalePage },
  metaInfo: { title: 'Students PA — Application' },
};
</script>

<style src="@/assets/css/customer-pa.css"></style>
